<mat-drawer-container class="main-layout">
  <mat-drawer mode="side" opened>
    <app-menu class="menu" (collapsedChange)="onMenuCollapsed()"></app-menu>
  </mat-drawer>
  <mat-drawer-content class="content">
    <ng-container *ngIf="gate$ | async as gate">
      <router-outlet *ngIf="gate.ready"></router-outlet>
      <p class="session-wait" *ngIf="!gate.ready">
        {{ (gate.needsOrganization ? 'app.session.chooseOrganization' : 'app.session.loading') | translate }}
      </p>
    </ng-container>
  </mat-drawer-content>
</mat-drawer-container>